import {
  requester
} from '../utils';

export const changePassword = (oldPassword, newPassword) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/panel/change-password`,
        method: 'PUT',
        data: {
          oldPassword,
          newPassword
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};